import type { CatalogTree } from '../types';

export const packs = {
  title: 'Sektör paketleri',
  packName: { jeweler: 'Kuyumcu' },
  versions: '{pack} sürümleri',
  versionNumber: '{n}. sürüm',
  default: 'Varsayılan',
  created: 'Oluşturan: {by}, {at}',
  published: 'Yayınlanma: {at}',
  pinned: 'Sabitlenen işletme: {count}',
  sections: {
    schema: 'Özellik şeması',
    rules: 'Çıkarım kuralları',
    policies: 'Varsayılan politikalar',
    topics: 'Varsayılan personele aktarma konuları',
    instructions: 'Asistan yönergeleri',
    copy: 'Kurulum metinleri',
    banned: 'Yasaklı ifadeler',
    disclosure: 'Yapay zekâ açıklama cümlesi',
  },
  columns: {
    key: 'Anahtar',
    type: 'Tür',
    unit: 'Birim',
    label: 'Türkçe ad',
    attribute: 'Özellik',
    pattern: 'Desen',
    transform: 'Dönüşüm',
    text: 'Metin',
  },
  cellLabel: '{column}, satır {row}',
  policyTopic: {
    shipping: 'Kargo',
    delivery_time: 'Teslimat süresi',
    cash_on_delivery: 'Kapıda ödeme',
    payment_methods: 'Ödeme yöntemleri',
    instalments: 'Taksit',
    returns_exchanges: 'İade ve değişim',
    certificates_invoices: 'Sertifika ve fatura',
    address_hours: 'Adres ve çalışma saatleri',
    pickup: 'Mağazadan teslim',
    custom_orders: 'Kişiye özel siparişler',
    faq: 'Sık sorulan sorular',
  },
  newVersion: 'Yeni sürüm',
  newVersionDescription:
    '{n}. sürümden doldurulmuştur. Kaydedilen her içerik yeni bir taslak sürüm olur.',
  create: 'Yeni sürüm oluştur',
  addRow: 'Satır ekle',
  removeRow: 'Satırı sil',
  bannedHint: 'Her satıra bir ifade.',
  publish: 'Yayınla',
  publishTitle: '{n}. sürümü yayınla',
  publishText:
    'Yayınlanan sürüm değiştirilemez. Varsayılanları paket düzeyinde ayar olarak yazılır.',
  rollout: 'Yaygınlaştır',
  rolloutTitle: '{n}. sürümü yaygınlaştır',
  rolloutText: 'Yeni işletmeler {n}. sürümü alır.',
  migrate: 'Mevcut işletmeleri de taşı',
  migrateText:
    '{count} işletme bu sürüme taşınır; işletme düzeyindeki değişiklikler korunur. Özellik şeması ve çıkarım kuralları kataloglara uygulanır.',
} as const satisfies CatalogTree;
